import { Component, Prop, Mixins } from 'vue-property-decorator';

interface route {
    name: string;
    params?: { [k: string]: any };
    query?: { [k: string]: any };
}

interface service {
    name: string;
    api: string;
}

@Component
/**
 * ProfileUserInfo Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * User Info
     */
    @Prop() user!: { [k: string]: any };

    /**
     * User Metadata
     */
    @Prop() userMetadata!: { [k: string]: any };

    /**
     * Exclude User Info
     */
    @Prop({ default: () => ['id', 'username', 'avatar'] }) excludeInfo!: Array<string>;

    /**
     * Raised Sidebar
     */
    @Prop({ type: Boolean }) raised!: boolean;

    /**
     * Has Edit Button
     */
    @Prop() editLink!: route;

    /**
     * Edit Mode
     */
    @Prop({ type: Boolean }) isEdit!: boolean;

    /**
     * Edit Service
     */
    @Prop({ default: () => ({ name: 'Person', api: 'userEditProfileSave' }) }) editService!: service;

    /**
     * Success Edit Message
     */
    @Prop() successEditMessage!: string;
}
